import { useState, useEffect } from 'react';
import { combineStyles } from 'helpers/helpers';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  fetchBrand,
  fetchBrandConfigModulesPack,
  fetchPaymentTypes,
  updateBrandConfigModulesPack,
} from 'actions/Brands';
import withStyles from '@material-ui/core/styles/withStyles';
import { get, put } from 'helpers/apiHelpers';
import isEmpty from 'lodash/isEmpty';
import { toast } from 'react-toastify';

import OrderFormView from './OrderForm.view';
import { withOrderFormBannerDefaults } from './components/BannerSettings';

const OrderFormContainer = ({
  classes,
  t,
  selectedBrand,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchBrand,
  paymentTypes,
  // eslint-disable-next-line no-shadow -- FIXME
  updateBrandConfigModulesPack,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [modules, setModules] = useState({
    ConfigClientPanel: {
      omnibusEnabledForDefaultPrices: true,
      showMenuPreviewOnOrderForm: true,
      enableVariantStep: true,
      useAddressesWithLessFields: true,
      showDiscountCodeInputInBasket: true,
      initialBasketId: null,
      calculatorMode: true,
      calculatorLink: true,
      isOneTimePayPaymentMode: true,
      isSubscriptionPaymentMode: true,
      defaultPaymentMode: true,
      showKnowAboutUs: false,
    },
    Seo: {
      ogImage: null,
      metaTitle: '',
      indexing: false,
      metaKeywords: '',
      ogTitle: '',
      metaDescription: 'false',
      ogDescription: '',
    },
  });

  const [hoverState, setHoverState] = useState({
    title: '',
    image: null,
    imageUrl: '',
    active: false,
    description: '',
  });

  const [state, setState] = useState({
    allowVariantAutoScroll: false,
    allowDietScroll: false,
    allowOrderTypeScroll: false,
    allowDietTimeScroll: false,
    allowCalendarScroll: false,
    allowCalorificScroll: false,
    showMenuPreviewOnOrderForm: false,
    showPricePreview: false,
    ecoContainer: false,
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const brandConfig = await fetchBrand(selectedBrand);

      const modulesConfig = await get(`brands/${selectedBrand}/modules`, null, {
        params: {
          module: ['ConfigClientPanel', 'Seo', 'OrderFormBanner'],
        },
      });

      setState(prevState => ({
        ...prevState,
        allowVariantAutoScroll: brandConfig.allowVariantAutoScroll,
        allowDietScroll: brandConfig.allowDietScroll,
        allowOrderTypeScroll: brandConfig.allowOrderTypeScroll,
        allowDietTimeScroll: brandConfig.allowDietTimeScroll,
        allowCalendarScroll: brandConfig.allowCalendarScroll,
        allowCalorificScroll: brandConfig.allowCalorificScroll,
        showPricePreview: brandConfig.showPricePreview,
        ecoContainer: brandConfig.ecoContainer,
      }));
      setModules({
        ...modulesConfig.configuration,
        OrderFormBanner: withOrderFormBannerDefaults(
          modulesConfig.configuration?.OrderFormBanner
        ),
      });
      setIsLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  // eslint-disable-next-line consistent-return -- FIXME
  const handleSubmit = () => {
    if (isEmpty(hoverState.title)) {
      return toast.error(t('form.fillAllRequiredFields'));
    }

    const hoverData = {
      title: hoverState.title,
      active: hoverState.active,
      image: hoverState.image,
      imageUrl: hoverState.image?.['@id'] || null,
      description: hoverState.description,
    };

    const data = {
      allowVariantAutoScroll: state.allowVariantAutoScroll,
      allowDietScroll: state.allowDietScroll,
      allowOrderTypeScroll: state.allowOrderTypeScroll,
      allowDietTimeScroll: state.allowDietTimeScroll,
      allowCalendarScroll: state.allowCalendarScroll,
      allowCalorificScroll: state.allowCalorificScroll,
      showMenuPreviewOnOrderForm: state.showMenuPreviewOnOrderForm,
      showPricePreview: state.showPricePreview,
      ecoContainer: state.ecoContainer,
    };

    try {
      Promise.all([
        put(`/brands/${selectedBrand}/hover`, {
          hover: hoverData,
        }),
        put(`/brands/${selectedBrand}`, data),
        updateBrandConfigModulesPack(selectedBrand, modules),
        // eslint-disable-next-line promise/prefer-await-to-then, @typescript-eslint/no-unused-vars -- FIXME
      ]).then(response => {
        toast.success(t('success.changesSaved'));
      });
    } catch (error) {
      toast.error(
        error?.message
          ? `${t('errors.changesCouldNotBeSaved')}: ${error.message}`
          : t('errors.changesCouldNotBeSaved')
      );
    }
  };

  const handleOrderFormBannerChange = orderFormBanner => {
    setModules(prevModules => ({
      ...prevModules,
      OrderFormBanner: orderFormBanner,
    }));
  };

  const props = {
    isLoading,
    modules,
    setModules,
    hoverState,
    setHoverState,
    state,
    setState,
    handleSubmit,
    handleOrderFormBannerChange,
    classes,
    paymentTypes,
    t,
  };

  return <OrderFormView props={props} />;
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const enhance = compose(
  withTranslation(),
  connect(
    ({ Auth: { selectedBrand }, Brands: { paymentTypes } }) => ({
      selectedBrand,
      paymentTypes,
    }),
    {
      fetchBrand,
      fetchBrandConfigModulesPack,
      fetchPaymentTypes,
      updateBrandConfigModulesPack,
    }
  ),
  withStyles(combinedStyles)
);

export default enhance(OrderFormContainer);
